import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
import { ApiEpSocialAccountConnect } from "./connect";
export class ApiEpSocialAccount {
}
/**
 * Used to connect Disconnect via Credential (id)
 */
ApiEpSocialAccount.disconnect = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/social-account/disconnect/${req.path.smp_account_credential_id}`,
    method: "POST",
});
/**
 * Used to get Account
 */
ApiEpSocialAccount.getById = ({ id, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/socialaccount/${id}`,
    method: "GET",
});
/**
 * Used to get Accounts list
 */
ApiEpSocialAccount.list = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/socialaccount`,
    method: "GET",
});
/**
 * Used to retrieve default Privacy settings for TikTok
 */
ApiEpSocialAccount.retrieveFreshData = (id) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/social-account/fresh-data/${id}`,
    method: "GET",
});
ApiEpSocialAccount.Connect = ApiEpSocialAccountConnect;
//# sourceMappingURL=social_account.js.map